export const ExternalLinks = {
  PRIVACY_POLICY: 'https://clinlife.de/page/legal-and-privacy',
  IMPRINT: 'https://clinlife.de/page/imprint',
  TERMS_OF_USE: 'https://clinlife.de/page/terms-of-use',
};
